// extracted by mini-css-extract-plugin
export default {"root":"WhiteList_root__t7H3D","subtitle":"WhiteList_subtitle__8AcG6","content":"WhiteList_content__MwPfE"};